import Vue from 'vue';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Home',
    meta: { menu: 'home' },
    component: () => import('../views/home.vue'),
  },
  {
    path: '/home',
    name: 'Home',
    meta: { menu: 'home' },
    component: () => import('../views/home.vue'),
  },
  {
    path: '/service',
    name: 'Service',
    meta: { menu: 'service' },
    component: () => import('../views/service/index.vue'),
  },
  {
    path: '/about',
    name: 'About',
    meta: { menu: 'about' },
    component: () => import('../views/about/index.vue'),
  },
  {
    path: '/download',
    name: 'Download',
    meta: { menu: 'download' },
    component: () => import('../views/download/index.vue'),
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
